module.exports = __webpack_public_path__ + "img/20MY_PH_EU_LHD_INFORM_SEAT_190523.b45a1f41.jpg";